import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import {
  type FormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { createChoiceFormField } from '@ns/plugin-picker-toolbox';

import { useTessaLicenseTypeSource } from './tessa-license-types-source';

type FormFieldExtension<TName extends string> = ExtensionDefinition<{
  kind: 'scaffolder-form-field';
  name: TName;
  params: { field: () => Promise<FormField> };
}>;

export const TessaLicenseTypePicker = createChoiceFormField({
  baseConfig: {},
  name: 'TessaLicenseTypePicker',
  useSource: useTessaLicenseTypeSource,
});

export const tessaLicenseTypePickerExtension: FormFieldExtension<'license-type-picker'> =
  FormFieldBlueprint.make({
    name: 'license-type-picker',
    params: { field: async () => TessaLicenseTypePicker },
  });
